import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ArrowRight } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    path: '/'
  }, {
    name: 'Servicios',
    path: '/#services'
  }, {
    name: 'Proyectos',
    path: '/proyectos'
  }, {
    name: 'Quiénes Somos',
    path: '/quienes-somos'
  }];
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/95 backdrop-blur-md ${isScrolled ? 'shadow-lg py-4' : 'py-6'}`} data-id="element-192">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-193">
        <div className="flex items-center justify-between" data-id="element-194">
          {/* Logo */}
          <Link to="/" className="text-2xl font-black tracking-tighter text-blue-900" data-id="element-195">
            FORAX<span className="text-blue-600" data-id="element-196">.</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-197">
            {navLinks.map(link => <Link key={link.name} to={link.path} className="text-sm font-medium text-gray-700 transition-colors hover:text-blue-600" onClick={e => {
            if (link.path.startsWith('/#')) {
              // Handle anchor links if on home page, otherwise navigate
              if (location.pathname === '/') {
                e.preventDefault();
                scrollToSection(link.path.substring(2));
              }
            }
          }} data-id="element-198">
                {link.name}
              </Link>)}
            <Link to="/#contact" className="group inline-flex items-center gap-2 rounded-full bg-blue-600 px-5 py-2.5 text-sm font-bold text-white transition-all hover:bg-blue-700 hover:shadow-lg hover:shadow-blue-600/20" onClick={e => {
            if (location.pathname === '/') {
              e.preventDefault();
              scrollToSection('contact');
            }
          }} data-id="element-199">
              Conversemos
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-200" />
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-gray-800" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-201">
            {isMobileMenuOpen ? <X data-id="element-202" /> : <Menu data-id="element-203" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-204">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-b border-gray-100 overflow-hidden" data-id="element-205">
            <div className="px-4 py-6 space-y-4" data-id="element-206">
              {navLinks.map(link => <Link key={link.name} to={link.path} className="block text-lg font-medium text-gray-900" onClick={() => setIsMobileMenuOpen(false)} data-id="element-207">
                  {link.name}
                </Link>)}
              <Link to="/#contact" className="block w-full text-center rounded-xl bg-blue-600 px-5 py-3 text-base font-bold text-white" onClick={() => setIsMobileMenuOpen(false)} data-id="element-208">
                Conversemos
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}